import React from 'react';

const Tool03Panel = ({ toolProps, onUpdate }) => {
  const {
    fillEdgesImageWidth,
    fillEdgesImageHeight,
    fillEdgesFillColor,
    fillEdgesStrokeColor,
    fillEdgesStrokeWidth,
    fillEdgesBackgroundColor,
    fillEdgesBackgroundThreshold,
    aColor,
    aAngle,
    aThickness,
    aSpacing,
    bColor,
    bAngle,
    bThickness,
    bSpacing
  } = toolProps;

  const handleChange = (key, value) => {
    onUpdate(key, value);
  };

  return (
    <div className="panel">
      <h2>Fill Edges</h2>
      <div className="panel-controls">
        {/* Image Width */}
        <div className="control-group">
          <label>Image Width:</label>
          <div className="slider-group">
            <input
              type="range"
              min="300"
              max="1600"
              value={fillEdgesImageWidth}
              onChange={(e) => handleChange('fillEdgesImageWidth', Number(e.target.value))}
            />
            <span>{fillEdgesImageWidth}</span>
          </div>
        </div>

        {/* Image Height */}
        <div className="control-group">
          <label>Image Height:</label>
          <div className="slider-group">
            <input
              type="range"
              min="300"
              max="1200"
              value={fillEdgesImageHeight}
              onChange={(e) => handleChange('fillEdgesImageHeight', Number(e.target.value))}
            />
            <span>{fillEdgesImageHeight}</span>
          </div>
        </div>

        {/* Fill Color */}
        <div className="color-picker-group">
          <label>Fill Color</label>
          <div className="color-group">
            <input
              type="color"
              value={fillEdgesFillColor}
              onChange={(e) => handleChange('fillEdgesFillColor', e.target.value)}
            />
          </div>
        </div>

        {/* Stroke Color */}
        <div className="color-picker-group">
          <label>Stroke Color</label>
          <div className="color-group">
            <input
              type="color"
              value={fillEdgesStrokeColor}
              onChange={(e) => handleChange('fillEdgesStrokeColor', e.target.value)}
            />
          </div>
        </div>

        {/* Stroke Width */}
        <div className="control-group">
          <label>Stroke Width:</label>
          <div className="slider-group">
            <input
              type="range"
              min="1"
              max="10"
              value={fillEdgesStrokeWidth}
              onChange={(e) => handleChange('fillEdgesStrokeWidth', Number(e.target.value))}
            />
            <span>{fillEdgesStrokeWidth}</span>
          </div>
        </div>

        {/* Background Removal Threshold */}
        <div className="control-group">
          <label>Background Removal Threshold:</label>
          <div className="slider-group">
            <input
              type="range"
              min="50"
              max="255"
              value={fillEdgesBackgroundThreshold}
              onChange={(e) => handleChange('fillEdgesBackgroundThreshold', Number(e.target.value))}
            />
            <span>{fillEdgesBackgroundThreshold}</span>
          </div>
        </div>

        {/* Background Color */}
        <div className="color-picker-group">
          <label>Background Color:</label>
          <div className="color-group">
            <input
              type="color"
              value={fillEdgesBackgroundColor}
              onChange={(e) => handleChange('fillEdgesBackgroundColor', e.target.value)}
            />
          </div>
        </div>

        {/* A Group */}
        <div className="color-picker-group">
          <label>A Group Color</label>
          <div className="color-group">
            <input
              type="color"
              value={aColor}
              onChange={(e) => handleChange('aColor', e.target.value)}
            />
          </div>
        </div>

        <div className="control-group">
          <label>A Group Angle:</label>
          <div className="slider-group">
            <input
              type="range"
              min="0"
              max="180"
              value={aAngle}
              onChange={(e) => handleChange('aAngle', Number(e.target.value))}
            />
            <span>{aAngle}°</span>
          </div>
        </div>

        <div className="control-group">
          <label>A Group Thickness:</label>
          <div className="slider-group">
            <input
              type="range"
              min="1"
              max="10"
              value={aThickness}
              onChange={(e) => handleChange('aThickness', Number(e.target.value))}
            />
            <span>{aThickness}px</span>
          </div>
        </div>

        <div className="control-group">
          <label>A Group Spacing:</label>
          <div className="slider-group">
            <input
              type="range"
              min="5"
              max="100"
              value={aSpacing}
              onChange={(e) => handleChange('aSpacing', Number(e.target.value))}
            />
            <span>{aSpacing}px</span>
          </div>
        </div>

        {/* B Group */}
        <div className="color-picker-group">
          <label>B Group Color</label>
          <div className="color-group">
            <input
              type="color"
              value={bColor}
              onChange={(e) => handleChange('bColor', e.target.value)}
            />
          </div>
        </div>

        <div className="control-group">
          <label>B Group Angle:</label>
          <div className="slider-group">
            <input
              type="range"
              min="0"
              max="180"
              value={bAngle}
              onChange={(e) => handleChange('bAngle', Number(e.target.value))}
            />
            <span>{bAngle}°</span>
          </div>
        </div>

        <div className="control-group">
          <label>B Group Thickness:</label>
          <div className="slider-group">
            <input
              type="range"
              min="1"
              max="10"
              value={bThickness}
              onChange={(e) => handleChange('bThickness', Number(e.target.value))}
            />
            <span>{bThickness}px</span>
          </div>
        </div>

        <div className="control-group">
          <label>B Group Spacing:</label>
          <div className="slider-group">
            <input
              type="range"
              min="5"
              max="100"
              value={bSpacing}
              onChange={(e) => handleChange('bSpacing', Number(e.target.value))}
            />
            <span>{bSpacing}px</span>
          </div>
        </div>
      </div>
      <div className="panel-footer">
        <button className="action-btn" onClick={toolProps.downloadFillEdgesSVG}>
          download SVG
        </button>
      </div>
    </div>
  );
};

export default Tool03Panel;
